import React, { useState } from "react";
import { EditIcon } from "../../common/icons/Icon";
import Deleteicon from "../../../assets/img/svg/delete-icon.svg";
import { useDispatch } from "react-redux";
import { deleteGearDetails } from "../../../redux/action/creator/CreatorGrarsWorkAction";
import Loader from "../../common/Loader";
import GearPoup from "./GearPoup";
import VideoPlayModal from "./VideoPlayModal";

function CreaterProfileGear({ item, index, userGearList }) {
  const [openEditForm, setOpenEditForm] = useState(false);
  const [IndexValue, setIndex] = useState(0);

  const dispatch = useDispatch();
  const [indexValue, setIndexValue] = useState(null);
  const [deleteLoading, setDeleteLoading] = useState(null);

  const handleClose = () => setOpenEditForm(false);

  const EditPastWork = (index) => {
    setOpenEditForm(true);
    setIndex(index);
  };
  return (
    <>
      <div className="row my-4">
        <div className="col">
          <div className="box-shadow br-10">
            <div className="d-flex flex-column flex-xl-row">
              <div className="col-lg-3  col-sm-4  col-7">
                <VideoPlayModal item={item} type={"gear"} />
              </div>

              <div className="col-xl-8 col-xxl-9 col-12 d-flex justify-content-center flex-column px-3 px-xl-4 py-3">
                <h4 className="common-heading-Medium  sm-font ">
                  {item.title}
                </h4>
                <span className="jobs-client d-inline-block mb-2">
                  {item.type}
                </span>
                <p className="common-text max-w-956 ">{item.description}</p>
                <div className="d-flex flex-column flex-sm-row">
                  <button
                    className="py-2 px-3 atech-primary-button "
                    onClick={() => EditPastWork(index)}
                  >
                    <span className="edit-icon pe-2">
                      <EditIcon />
                    </span>
                    Edit
                  </button>

                  <button
                    className="py-2 px-3 mt-3 mt-sm-0 ms-0 ms-sm-2 atech-fade-button"
                    onClick={() => {
                      dispatch(deleteGearDetails(item.id, setDeleteLoading));
                      setIndexValue(index);
                    }}
                  >
                    {deleteLoading && index === indexValue ? (
                      <Loader />
                    ) : (
                      <>
                        <img src={Deleteicon} alt="" />
                        <span className="ms-2">Delete</span>
                      </>
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {openEditForm ? (
        <GearPoup
          handleClose={handleClose}
          show={openEditForm}
          gearWorkArray={userGearList}
          index={IndexValue}
        />
      ) : null}
    </>
  );
}

export default CreaterProfileGear;
